
const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const fetchLeadOrders = async (leadId, status = 'open', page = 1, perPage = 10) => {
    const token = localStorage.getItem('token');

    if (!token) {
        console.error('[fetchLeadOrders] Ошибка: Токен авторизации не найден.');
        // throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/lead/leads/${leadId}/orders?page=${page}&per_page=${perPage}&status=${status}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`[fetchLeadOrders] Ошибка загрузки заказов для лида ${leadId}:`, errorData);
            throw { ...errorData, statusCode: response.status };
        }

        const result = await response.json();
        return {
            data: result.data || [],
            meta: {
                total_count: result.meta?.total || 0,
                current_page: result.meta?.current_page || page,
                per_page: result.meta?.per_page || perPage,
                total_pages: result.meta?.last_page || 1
            }
        };
    } catch (error) {
        console.error(`[fetchLeadOrders] Ошибка сети или другая ошибка при запросе заказов для лида ${leadId}:`, error);
        throw error;
    }
};
